import Popup from "../../../components/base/popup";
import Form from "../../../components/base/forms/form";
import {AnalyticsService} from "../../../services/analytics-service";

export default class WidgetLeadMagnet extends Popup {
	constructor(props = {}) {
		super(props);

		this.$root = document.querySelector('.widget-lead-magnet');

		this.cookie = costorage.get('h_leadMagnet');
		this.showDelay = props.showDelay || 5000;
		this.data = props.data || { city: craft.env.cityId }

		const consultationRequestedCookie = costorage.get('h_consultationRequested');

		if (props.relatedSprintSlug && !costorage.get(`h_magnet-${props.relatedSprintSlug}`)) {
			this.$root = document.querySelector('.widget-sprint-magnet');

			this.relatedSprintSlug = props.relatedSprintSlug;
			this.cookie = costorage.get(`h_magnet-${props.relatedSprintSlug}`);

			this.init();
		} else if (!consultationRequestedCookie) {
			this.init();
		}
	}

	init() {
		if (this.$root == null || this.cookie || !window.matchMedia('(min-width: 769px)').matches) {
			return;
		}

		setTimeout(() => {
			if (this.relatedSprintSlug) {
				this.initSprintMagnet();
			} else {
				this.initForm();
			}

			this.show();
		}, this.showDelay);

		super.init();
	}

	initSprintMagnet() {
		const $siteLink = document.querySelector('.sprint-magnet-site');
		const $lmsLink = document.querySelector('.sprint-magnet-lms');

		[$siteLink, $lmsLink].forEach(($link) => {
			$link.addEventListener('click', (e) => {
				e.preventDefault();
				this.setCookie();
				location.href = $link.href;
			});
		});
	}

	initForm() {
		try {
			const form = new Form({
				formId: 'lead-magnet',
				uri: '/1.0/courses/lead-magnet',
				data: this.data,
				submitConf: {
					animation: false
				},
				subscriptions: [{
					event: 'beforeSubmit',
					callback: () => {
						/* GTM Event */
						const dataLayerEventData = {
							event: 'leadmagnet_popup_form',
							formId: form.formId,
							phone: form.data.tel,
							email: form.data.email
						};

						const $formTitle = form.$root.querySelector('.form_title');

						if ($formTitle) {
							dataLayerEventData.formName = $formTitle.textContent;
						}

						AnalyticsService.sendEvent('leadmagnet_popup_form', dataLayerEventData);

						this.hide();
					}
				}]
			});
		} catch (err) {
			console.error('Lead Magnet Form:', err);
		}
	}

	setCookie() {
		costorage.set(this.relatedSprintSlug ? `h_magnet-${this.relatedSprintSlug}` : 'h_leadMagnet', 1, {
			expires: 45 * 24 * 60 * 60,
			domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua',
			path: "/"
		});
	}

	hide() {
		super.hide();
		this.setCookie();
	}
}